import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrientationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 16,
		r: 2,
		fill: "currentColor",
		stroke: "none"
	}), /* @__PURE__ */ _jsx("path", { d: "M10 16h11M10 16V4M10 16l-6 5" })]
});
export default SvgOrientationIcon;
